/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerimeterPointDto } from './PerimeterPointDto';
import {
    PerimeterPointDtoFromJSON,
    PerimeterPointDtoFromJSONTyped,
    PerimeterPointDtoToJSON,
    PerimeterPointDtoToJSONTyped,
} from './PerimeterPointDto';

/**
 * 
 * @export
 * @interface UpdateZoneRequestDto
 */
export interface UpdateZoneRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateZoneRequestDto
     */
    siteId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateZoneRequestDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateZoneRequestDto
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateZoneRequestDto
     */
    longitude?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateZoneRequestDto
     */
    isMain?: boolean;
    /**
     * Polygon perimeter points describing the covered area.
     * @type {Array<PerimeterPointDto>}
     * @memberof UpdateZoneRequestDto
     */
    perimeter?: Array<PerimeterPointDto> | null;
}

/**
 * Check if a given object implements the UpdateZoneRequestDto interface.
 */
export function instanceOfUpdateZoneRequestDto(value: object): value is UpdateZoneRequestDto {
    return true;
}

export function UpdateZoneRequestDtoFromJSON(json: any): UpdateZoneRequestDto {
    return UpdateZoneRequestDtoFromJSONTyped(json, false);
}

export function UpdateZoneRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateZoneRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'isMain': json['isMain'] == null ? undefined : json['isMain'],
        'perimeter': json['perimeter'] == null ? undefined : ((json['perimeter'] as Array<any>).map(PerimeterPointDtoFromJSON)),
    };
}

export function UpdateZoneRequestDtoToJSON(json: any): UpdateZoneRequestDto {
    return UpdateZoneRequestDtoToJSONTyped(json, false);
}

export function UpdateZoneRequestDtoToJSONTyped(value?: UpdateZoneRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'siteId': value['siteId'],
        'name': value['name'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'isMain': value['isMain'],
        'perimeter': value['perimeter'] == null ? undefined : ((value['perimeter'] as Array<any>).map(PerimeterPointDtoToJSON)),
    };
}

